/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * neighborsReports
 * @export
 * @interface NeighborsRequest
 */
export interface NeighborsRequest {
    /**
     * 営業所ID
     * @type {number}
     * @memberof NeighborsRequest
     */
    officeId?: number;
    /**
     * 空車での trip_session_id
     * @type {string}
     * @memberof NeighborsRequest
     */
    unladenTripSessionId?: string;
    /**
     * 空車開始時刻(UTC, フォーマット '2023-05-02T04:13:18Z')
     * @type {string}
     * @memberof NeighborsRequest
     */
    unladenStartTs?: string;
}

export function NeighborsRequestFromJSON(json: any): NeighborsRequest {
    return NeighborsRequestFromJSONTyped(json, false);
}

export function NeighborsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NeighborsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'unladenTripSessionId': !exists(json, 'unladen_trip_session_id') ? undefined : json['unladen_trip_session_id'],
        'unladenStartTs': !exists(json, 'unladen_start_ts') ? undefined : json['unladen_start_ts'],
    };
}

export function NeighborsRequestToJSON(value?: NeighborsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office_id': value.officeId,
        'unladen_trip_session_id': value.unladenTripSessionId,
        'unladen_start_ts': value.unladenStartTs,
    };
}


